import React from 'react'
import { InputGroup } from '@chakra-ui/react'

export default (props) => {
  return (
    <InputGroup size={props.size} w={props.w} maxW={props.maxW} mb={props.mb} mt={props.mt} startAddon={props.startAddon} startElement={props.leftIcon || props.startElement} endElement={props.endElement}>
      {props.children}
    </InputGroup>
  )
}
